import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { internalCreators } from '../creators';
import { isPredicateOperator } from '../types';
import { notUndefined } from '../utils';
import { getPositionFromContext, JastBuildingVisitor } from './common';
import { OperandVisitor } from './operand';
export var PredicateVisitor = /*#__PURE__*/function (_JastBuildingVisitor) {
  _inherits(PredicateVisitor, _JastBuildingVisitor);
  var _super = _createSuper(PredicateVisitor);
  function PredicateVisitor() {
    var _this;
    _classCallCheck(this, PredicateVisitor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "predicateOperatorVisitor", new PredicateOperatorVisitor(_this.tokens));
    _defineProperty(_assertThisInitialized(_this), "predicateOperandVisitor", new PredicateOperandVisitor(_this.tokens));
    _defineProperty(_assertThisInitialized(_this), "visitJqlWasPredicate", function (ctx) {
      var operator = _this.getOperatorForContexts([ctx.jqlDatePredicateOperator(), ctx.jqlDateRangePredicateOperator(), ctx.jqlUserPredicateOperator()]);
      var operand = ctx.jqlPredicateOperand().accept(_this.predicateOperandVisitor);
      var position = getPositionFromContext(ctx);
      return internalCreators.predicate(operator, operand, position);
    });
    _defineProperty(_assertThisInitialized(_this), "visitJqlChangedPredicate", function (ctx) {
      var operator = _this.getOperatorForContexts([ctx.jqlDatePredicateOperator(), ctx.jqlDateRangePredicateOperator(), ctx.jqlUserPredicateOperator(), ctx.jqlValuePredicateOperator()]);
      var operand = ctx.jqlPredicateOperand().accept(_this.predicateOperandVisitor);
      var position = getPositionFromContext(ctx);
      return internalCreators.predicate(operator, operand, position);
    });
    _defineProperty(_assertThisInitialized(_this), "getOperatorForContexts", function (contexts) {
      var operatorContext = contexts.find(notUndefined);
      if (operatorContext !== undefined) {
        return operatorContext.accept(_this.predicateOperatorVisitor);
      } else {
        throw new Error('Undefined predicate operator context');
      }
    });
    return _this;
  }
  return _createClass(PredicateVisitor);
}(JastBuildingVisitor);
var PredicateOperatorVisitor = /*#__PURE__*/function (_JastBuildingVisitor2) {
  _inherits(PredicateOperatorVisitor, _JastBuildingVisitor2);
  var _super2 = _createSuper(PredicateOperatorVisitor);
  function PredicateOperatorVisitor() {
    var _this2;
    _classCallCheck(this, PredicateOperatorVisitor);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "visitJqlDatePredicateOperator", function (ctx) {
      return _this2.getPredicateOperator(ctx);
    });
    _defineProperty(_assertThisInitialized(_this2), "visitJqlDateRangePredicateOperator", function (ctx) {
      return _this2.getPredicateOperator(ctx);
    });
    _defineProperty(_assertThisInitialized(_this2), "visitJqlUserPredicateOperator", function (ctx) {
      return _this2.getPredicateOperator(ctx);
    });
    _defineProperty(_assertThisInitialized(_this2), "visitJqlValuePredicateOperator", function (ctx) {
      return _this2.getPredicateOperator(ctx);
    });
    _defineProperty(_assertThisInitialized(_this2), "getPredicateOperator", function (ctx) {
      var text = _this2.tokens.getText(ctx);

      // Replace consecutive whitespace chars with single space
      var value = text.toLowerCase().replace(/\s+/g, ' ');
      if (!isPredicateOperator(value)) {
        throw new Error("Found a history predicate operator which does not map to a changed time predicate operator in the ast: ".concat(text));
      }
      return internalCreators.predicateOperator(value, text, getPositionFromContext(ctx));
    });
    return _this2;
  }
  return _createClass(PredicateOperatorVisitor);
}(JastBuildingVisitor);
var PredicateOperandVisitor = /*#__PURE__*/function (_JastBuildingVisitor3) {
  _inherits(PredicateOperandVisitor, _JastBuildingVisitor3);
  var _super3 = _createSuper(PredicateOperandVisitor);
  function PredicateOperandVisitor() {
    var _this3;
    _classCallCheck(this, PredicateOperandVisitor);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this3 = _super3.call.apply(_super3, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this3), "operandVisitor", new OperandVisitor(_this3.tokens));
    _defineProperty(_assertThisInitialized(_this3), "visitJqlPredicateOperand", function (ctx) {
      return ctx.jqlOperand().accept(_this3.operandVisitor);
    });
    return _this3;
  }
  return _createClass(PredicateOperandVisitor);
}(JastBuildingVisitor);